import React from 'react';

export const CommonServicePage = ({ currentService }) => {
  return (
    <div className="mt-[8rem] flex w-full justify-center bg-[#00142C] py-[4rem] font-inter">
      <div className="flex w-full max-w-[114rem] flex-row flex-wrap items-stretch justify-center gap-x-[1rem] gap-y-[3rem] px-[2rem]">
        {/* Hero Section */}

        <div className="mb-[4rem] text-center">
          <h1 className="pt-[4rem] text-[3.6rem] font-[600] leading-[4.65rem] text-white md:pt-[6rem] lg:pt-[10rem]">
            {' '}
            {currentService.mainHeader}
          </h1>

          <h1
            className="mb-[2rem] mt-[4rem] w-full text-justify text-[1.6rem] font-[400] leading-[2.4rem] text-[#828FA0]"
            dangerouslySetInnerHTML={{ __html: currentService.mainSubHeader }}
          />
        </div>

        {/* Services Breakdown */}
        <div className="grid grid-cols-1 gap-[2rem] sm:grid-cols-2 lg:grid-cols-3">
          {currentService.subservices.map((item, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-start gap-3 rounded-xl bg-[#011936] p-6 text-center shadow-sm transition duration-200"
            >
              <img
                src={item.icon}
                alt={item.title}
                className="h-[15rem] w-[15rem] rounded-md object-cover"
              />
              <h3 className="text-[1.8rem] font-semibold text-[white]">{item.title}</h3>
              <p className="text-[1.4rem] text-[#828fa0]">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Why Choose Us Section */}
        <div className="mt-[6rem] rounded-2xl bg-[#011936] p-[3rem] text-center">
          <h2 className="mb-[1.5rem] text-[2.4rem] font-[700] text-white">
            {currentService.downHeader}
          </h2>
          <p className="mx-auto max-w-[800px] text-[1.6rem] leading-[3rem] text-[#828fa0]">
            {currentService.downSubHeader}
          </p>

          <div className="mt-[3rem] grid gap-[2rem] sm:grid-cols-2 lg:grid-cols-3">
            {currentService.whyChooseUs.map((card, index) => (
              <div
                key={index}
                className="rounded-xl border border-[#828fa0] bg-[#011936] p-6 transition"
              >
                <div className="text-[2.5rem]">{card.icon}</div>
                <h3 className="mt-2 text-[1.8rem] font-semibold text-white">{card.title}</h3>
                <p className="mt-2 text-[1.4rem] text-[#828fa0]">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
